import React, { useState, useCallback, useEffect } from 'react';
import { Layout } from 'antd';
import clsx from 'clsx';
import { checkIsMobile } from '../../lib';
import LeftMenu from './leftMenu';
import TopMenu from './topMenu';
import DropDownMenu from './dropDownMenu';

const { Header, Content, Sider } = Layout;

const MenuLayout = (props) => {
    const {
        // 擺放頁面內容
        children,
        pages = [],
        // 選單位置 ex: left、top
        menuPosition = 'top',
        isMenuOpen,
        currentRouteName,
        // onClickMenu: function(key)
        onClickMenu,
        // logo element
        logo,
        // 是否圓角
        menuRounded = false,
        // 是否開啟最愛功能
        favorites = false,
        // 導覽列內容
        toolBar,
        // 是否增加功能列陰影
        toolBarShadow = true,
        langConfig = {}
    } = props;

    const [layoutMenuPosition, setLayoutMenuPosition] = useState(menuPosition);
    useEffect(() => {
        setLayoutMenuPosition(menuPosition);
    }, [menuPosition]);

    const [layoutIsMenuOpen, setLayoutIsMenuOpen] = useState(isMenuOpen);
    const onChangeIsMenuOpen = useCallback((value) => {
        setLayoutIsMenuOpen(value);
        window.localStorage.setItem('isMenuOpen', value);
    }, []);
    useEffect(() => {
        if (isMenuOpen !== undefined) {
            onChangeIsMenuOpen(isMenuOpen);
        } else {
            onChangeIsMenuOpen(window.localStorage.getItem('isMenuOpen') !== 'false');
        }
    }, [onChangeIsMenuOpen, isMenuOpen]);

    useEffect(() => {
        // check is mobile
        const handleResize = () => {
            const isMobileWidth = checkIsMobile() || window.innerWidth <= 768;
            if (isMobileWidth) {
                setLayoutIsMenuOpen(false);
            } else {
                setLayoutIsMenuOpen(window.localStorage.getItem('isMenuOpen') === 'true');
            }
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [menuPosition, isMenuOpen]);

    const storageFavoritePages = window.localStorage.getItem('favoritePages');
    const [favoritePages, setFavoritePages] =
        useState(storageFavoritePages ? JSON.parse(storageFavoritePages) : []);
    const onClickFavoriteIcon = useCallback((page) => {
        const newPages = !favoritePages.includes(page) ?
            [...favoritePages, page] : favoritePages.filter((item) => item !== page);
        setFavoritePages(newPages);
        window.localStorage.setItem('favoritePages', JSON.stringify(newPages));
    }, [favoritePages]);
    const myFavorites = { open: favorites, favoritePages, onClickFavoriteIcon };

    return (
        <Layout
            className={
                `menu-layout w-screen h-screen ${menuRounded ? 'menu-rounded' : 'menu-no-rounded'}`
            }
        >
            {layoutMenuPosition === 'left' && layoutIsMenuOpen && (
                <Sider theme="light" className="bg-menu min-w-fit">
                    <LeftMenu
                        pages={pages}
                        setIsMenuOpen={onChangeIsMenuOpen}
                        currentRouteName={currentRouteName}
                        onClickMenu={onClickMenu}
                        logo={logo}
                        myFavorites={myFavorites}
                        langConfig={langConfig}
                    />
                </Sider>
            )}
            <Layout>
                {layoutMenuPosition === 'top' && layoutIsMenuOpen && (
                    <Header className="bg-menu">
                        <TopMenu
                            pages={pages}
                            setIsMenuOpen={onChangeIsMenuOpen}
                            currentRouteName={currentRouteName}
                            onClickMenu={onClickMenu}
                            logo={logo}
                            myFavorites={myFavorites}
                            langConfig={langConfig}
                        />
                    </Header>
                )}
                <Header className={clsx(
                    'px-4 text-menu-selected bg-toolbar dark:text-white dark:bg-black-light01',
                    { 'shadow-md': toolBarShadow }
                )}
                >
                    {!layoutIsMenuOpen && (
                        <div className="mr-4">
                            <DropDownMenu
                                pages={pages}
                                setIsMenuOpen={onChangeIsMenuOpen}
                                currentRouteName={currentRouteName}
                                onClickMenu={onClickMenu}
                                menuPosition={layoutMenuPosition}
                                myFavorites={myFavorites}
                                langConfig={langConfig}
                            />
                        </div>
                    )}
                    {toolBar}
                </Header>
                <Content>
                    {children}
                </Content>
            </Layout>
        </Layout>
    );
};

export default MenuLayout;
